/**
 * Created by Administrator on 2017/5/18.
 */
import Vue from 'vue';
import moment from 'moment';

Vue.filter('formatPercent', function (value, digit) {
    if (!value) value = 0;
    if (!digit) digit = 1;
    return (value * 100).toFixed(digit);
});

Vue.filter('format', function (value, format) {//{{v.createTime|format('YYYY-MM-DD')}}
    format = format || 'YYYY-MM-DD HH:mm:ss';
    return moment(value).format(format);
});
Vue.filter('formatDate', function (value) {//{{v.createTime|formatDate}}
    return moment(value).format("YYYY-MM-DD");
});
Vue.filter('formatDateDef', function (value, def) {//{{v.createTime|formatDate}}
    if(!value){
        return def
    }
    return moment(value).format("YYYY-MM-DD");
});
Vue.filter('formatTime', function (value) {//{{v.createTime|formatTime}}
    return moment(value).format("HH:mm:ss");
});
Vue.filter('formatLongTime', function (value) {//{{v.createTime|formatTime}}
    return moment(value).utc().format("HH:mm:ss");
});
Vue.filter('formatDateTime', function (value) {//{{v.createTime|formatDateTime}}
    return moment(value).format("YYYY-MM-DD HH:mm:ss");
});
Vue.filter('formatDateTimeDef', function (value, def) {//{{v.createTime|formatDate}}
    if(!value){
        return def
    }
    return moment(value).format("YYYY-MM-DD HH:mm:ss");
});
Vue.filter('formatFileSize', function (value, precision) {//{{v.fileSize|formatFileSize}}
    if (typeof precision !== "number") {
        precision = 2;
    }
    if (value > Math.pow(1024, 5)) {
        return (value / Math.pow(1024, 5)).toFixed(precision) + "PB";
    } else if (value > Math.pow(1024, 4)) {
        return (value / Math.pow(1024, 4)).toFixed(precision) + "TB";
    } else if (value > Math.pow(1024, 3)) {
        return (value / Math.pow(1024, 3)).toFixed(precision) + "GB";
    } else if (value > Math.pow(1024, 2)) {
        return (value / Math.pow(1024, 2)).toFixed(precision) + "MB";
    } else {
        return (value / 1024).toFixed(precision) + "KB";
    }
});
// 3GB 423M 22.23KB
Vue.filter('formatFileSizeStep', function (value) {//{{v.fileSize|formatFileSize}}
    var result = "";
    if (value >= Math.pow(1024, 5)) {
        result += Math.floor((value / Math.pow(1024, 5))) + "PB ";
        value = value % Math.pow(1024, 5);
    }
    if (value >= Math.pow(1024, 4)) {
        result += Math.floor((value / Math.pow(1024, 4))) + "TB ";
        value = value % Math.pow(1024, 4);
    }
    if (value >= Math.pow(1024, 3)) {
        result += Math.floor((value / Math.pow(1024, 3))) + "GB ";
        value = value % Math.pow(1024, 3);
    }
    if (value >= Math.pow(1024, 2)) {
        result += Math.floor((value / Math.pow(1024, 2))) + "MB ";
        value = value % Math.pow(1024, 2);
    }
    if (value >= 1024) {
        result += (value / 1024).toFixed(2) + "KB";
    }
    return result;
});

Vue.filter('leftPad', function (value, size, str) {//{{ v.num|leftPad(10, '0')}}
    if (value == null || value == undefined) {
        return value;
    }
    var result = "" + value;
    if (size <= result.length) {
        return result;
    }
    var pad = (typeof str === "string" && str.length == 1) ? str : "0";
    for (var idx = result.length; idx < size; idx++) {
        result = pad + result;
    }
    return result;
});

Vue.filter('leftPadZero', function (value, size) {//{{ v.num|leftPadZero(10)}}
    if (value == null || value == undefined) {
        return value;
    }
    var result = "" + value;
    if (size <= result.length) {
        return result;
    }
    for (var idx = result.length; idx < size; idx++) {
        result = "0" + result;
    }
    return result;
});

Vue.filter("formatTimestamp", function (value) {
    if (value == null || value == undefined) {
        return value;
    }
    const ONE_SECOND = 1000;
    const ONE_MIN = ONE_SECOND * 60;

    // 求得分钟数
    let min = parseInt((value / ONE_MIN));

    let result;

    result = leftPad(min, 2, '0') + ':';

    // 求得余数
    let remainder = value % ONE_MIN;

    let second = 0;
    if (remainder > 0) {
        second = parseInt(remainder / ONE_SECOND);
    }
    result = result + leftPad(second, 2, '0');
    return result;
})

Vue.filter("formatDuration", function (value) {
    if (value == null || value == undefined) {
        return value
    }
    if (value >= 3600) {
        return parseInt(value / 3600) + "小时";
    } else if (value >= 60) {
        return parseInt(value / 60) + "分钟";
    } else {
        return value + "秒";
    }
})

Vue.filter("formatMilliseconds", function (value,def) {
    if (value == null || value == undefined || value<1) {
        return def
    }
    let result = "";
    if (value >= 3600000) {
        result += parseInt(value / 3600000) + "小时";
        value = value % 3600000;
    }
    if (value >= 60000) {
        result += parseInt(value / 60000) + "分钟";
        value = value % 60000;
    }
    if(value>0) {
        result += Math.ceil(value / 1000) + "秒";
    }
    return result;
})

Vue.filter("formatSeconds", function (value,def) {
    if (value == null || value == undefined || value<1) {
        return def
    }
    let result = "";
    if (value >= 3600) {
        result += parseInt(value / 3600) + "小时";
        value = value % 3600;
    }
    if (value >= 60) {
        result += parseInt(value / 60) + "分钟";
        value = value % 60;
    }
    if(value>0) {
        result += Math.ceil(value) + "秒";
    }
    return result;
})


function leftPad(value, size, str) {
    if (value == null || value == undefined) {
        return value;
    }
    var result = "" + value;
    if (size <= result.length) {
        return result;
    }
    var pad = (typeof str === "string" && str.length == 1) ? str : "0";
    for (var idx = result.length; idx < size; idx++) {
        result = pad + result;
    }
    return result;
}






// WEBPACK FOOTER //
// ./src/common/js/common-filter.js